import { render, staticRenderFns } from "./synthesize-reform.vue?vue&type=template&id=787a341e&scoped=true&"
import script from "./synthesize-reform.vue?vue&type=script&lang=js&"
export * from "./synthesize-reform.vue?vue&type=script&lang=js&"
import style0 from "./synthesize-reform.vue?vue&type=style&index=0&id=787a341e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787a341e",
  null
  
)

export default component.exports